import { createRouter, createWebHistory } from 'vue-router'
import { getFirmByWebsite } from '../services/api'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: {
        template: `
          <div class="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div v-if="loading" class="text-center">
              <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
              <p class="text-gray-600">Loading firm...</p>
            </div>
            <div v-else-if="firmId" class="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
              <p class="text-gray-600">Redirecting to firm...</p>
            </div>
            <div v-else class="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
              <div class="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                <i class="pi pi-building text-3xl text-primary"></i>
              </div>
              <h1 class="text-2xl font-bold text-gray-900 mb-2">Firms Website</h1>
              <p class="text-gray-600 mb-6">Enter a firm ID to view the firm's website</p>
              <div class="flex gap-2">
                <input 
                  v-model="inputFirmId" 
                  type="text" 
                  placeholder="Enter firm ID" 
                  class="flex-1 px-4 py-2 border border-gray-200 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none"
                  @keyup.enter="goToFirm"
                />
                <button 
                  @click="goToFirm" 
                  class="px-6 py-2 bg-primary hover:bg-primary/90 text-white rounded-lg font-semibold transition-colors"
                >
                  Go
                </button>
              </div>
            </div>
          </div>
        `,
        data() {
          return { 
            inputFirmId: '',
            loading: true,
            firmId: null as string | null
          }
        },
        async mounted() {
          console.log('🏠 Root route mounted, attempting to load firm by origin')
          try {
            const res = await getFirmByWebsite()
            console.log('✅ Firm loaded by origin:', res.data)
            if (res.data?.success && res.data?.data?.firm_id) {
              this.firmId = res.data.data.firm_id
              console.log('🔄 Redirecting to firm:', this.firmId)
              window.location.href = `/${this.firmId}`
            } else {
              console.log('❌ No firm found for origin, showing input form')
              this.loading = false
            }
          } catch (e) {
            console.error('❌ Error loading firm by origin:', e)
            this.loading = false
          }
        },
        methods: {
          goToFirm() {
            if (this.inputFirmId) {
              window.location.href = `/${this.inputFirmId}`
            }
          }
        }
      }
    },
    {
      path: '/:id/login',
      name: 'firm-login',
      component: () => import('../pages/LoginPage.vue')
    },
    {
      path: '/:id/register',
      name: 'firm-register',
      component: () => import('../pages/RegisterPage.vue')
    },
    {
      path: '/:id/chat',
      name: 'firm-chat',
      component: () => import('../views/chat/index.vue')
    },
    {
      path: '/:id/chat/:chatId',
      name: 'firm-chat-detail',
      component: () => import('../views/chat/[id].vue')
    },
    {
      path: '/:id',
      name: 'firm-detail',
      component: () => import('../views/FirmWebsite.vue')
    }
  ]
})

export default router
